import React from 'react';
import {
	Css,
	IResponsiveImageSource,
	Responsive,
	StyledCardContent,
	StyledCardPicture,
} from '@/ui';
import styled from '@emotion/styled';
import BaseCard from './BaseCard';
import { Color } from '../../../styles/Color';
import { getHeadingStyle } from '../../../styles/utils/getHeadingStyle';
import { theme } from '../../../styles/theme';

interface IFeatureEntrypointProps {
	icon?: React.ReactNode;
	image?: IResponsiveImageSource;
	label: string;
	href?: string;
}

export default function FeatureEntrypoint({
	icon,
	image,
	label,
	href,
}: IFeatureEntrypointProps) {
	return (
		<BaseCard
			fullyClickable
			cardOrientation="horizontal"
			linkHref={href}
			type="feature"
		>
			<CardContentStyled>
				{icon && <FeatureIcon>{icon}</FeatureIcon>}
				{image && <StyledCardPicture source={image} alt={label} />}
				<h3>{label}</h3>
			</CardContentStyled>
		</BaseCard>
	);
}

const CardContentStyled = styled(StyledCardContent)`
	flex-direction: row;
	padding: ${Css.pxToRemFromTheme(16)};
	gap: ${Css.pxToRemFromTheme(24)};
	align-items: center;
	flex-wrap: wrap;
	justify-content: flex-start;

	h3 {
		${getHeadingStyle(theme, 'h6')}
		margin-bottom: 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		gap: ${Css.pxToRemFromTheme(16)};
	}
`;

const FeatureIcon = styled.div`
	display: flex;
	align-items: center;
	background-color: ${Color.PrimaryBlue97};
	padding: ${Css.pxToRemFromTheme(10)};
	border-radius: 10px;
`;
